export const sofDisableFormStatuses = {};

export const sofCannotDispatchStatuses = {
  'APPROVED PAID': true,
  'APPROVED FOR PAYMENT': true,
  'SUBMIT FOR PAYMENT': true,
  'VOIDED CLAIM': true
};
